var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramFesta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 28,
    viewBox: "0 0 220 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_15558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28L0 14L14 0L28 14L14 28ZM4.94755 14L14 23.0525L23.0525 14L14 4.94755L4.94755 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 19.8925L8.10742 13.9999L13.9999 8.10742L19.8925 13.9999L13.9999 19.8925ZM13.055 13.9999L13.9999 14.9449L14.9449 13.9999L13.9999 13.055L13.055 13.9999Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_15558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5579 1.6084H63.3877V26.3848H67.5579V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9231 1.6084H74.7529V26.3848H78.9231V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5795 11.2157L64.8018 15.2344L66.1484 19.1812L77.9262 15.1625L76.5795 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6487 1.6416H44V5.81181H58.6487V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4124 3.72656H49.2422V26.3582H53.4124V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8176 28L81.8096 13.1461L90.984 0L94.3996 2.38298L86.9396 13.0733L96.167 25.5177L92.8176 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4923 11.0283H84.3779V15.1985H94.4923V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_15558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.675 26.3409L182.37 8.7073L176.423 26.3077L172.475 24.9737L180.346 1.69236L182.084 1.67909L184.281 1.65918L192.597 24.9405L188.675 26.3409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.435 19.1271L182.544 16.2363L179.653 19.1271L182.544 22.0179L185.435 19.1271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.335 27.064H112.167V5.11663L122.328 0.935547L123.914 4.7848L116.335 7.90402V27.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.259 12.0315L113.391 16.0488L115.11 19.8453L123.979 15.828L122.259 12.0315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1 27.3168L143.532 24.0316L149.425 19.4324L142.019 10.4L151.642 0.564453L154.622 3.47794L147.613 10.6455L155.358 20.0895L146.1 27.3168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.488 1.5791H157.834V5.74691H172.488V1.5791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.245 3.66309H163.077V26.3007H167.245V3.66309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.762 28L125.752 13.1472L134.924 0L138.342 2.38256L130.882 13.0742L140.107 25.5179L136.762 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.435 11.0303H128.32V15.1981H138.435V11.0303Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_15558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_15558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1674,
    height: 28,
    fill: "white",
    transform: "translate(44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_15558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.4295,
    height: 28,
    fill: "white",
    transform: "translate(112.167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramFesta);
export default __webpack_public_path__ + "static/media/programFesta.d86a614ff76cfacf6ab242d19c320257.svg";
export { ForwardRef as ReactComponent };